/**
 * Ark Exotics — HQ booking popup v2.
 * 5 steps: Dates → Vehicles → Customer → Confirm → Payments
 */
(function () {
  'use strict';
  var $ = function (r, s) { return r.querySelector(s); };
  var $$ = function (r, s) { return [].slice.call(r.querySelectorAll(s)); };
  function parseFallback(raw) { try { return JSON.parse(String(raw || '').replace(/\r?\n/g, '')); } catch (e) { return {}; } }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '—' : '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmtDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fmtDisplay(s) { if (!s) return '—'; var p = s.split('-'); return p[1] + '/' + p[2] + '/' + p[0]; }
  function firstArr(o) { if (!o || typeof o !== 'object') return null; if (Array.isArray(o)) return o.length ? o : null; for (var k in o) if (Array.isArray(o[k]) && o[k].length) return o[k]; return null; }
  function isInsurance(c) { return /insurance|coverage|cdw|ldw|collision|protection|liability|waiver/.test(((c.name || c.title || c.label || '') + '').toLowerCase()); }

  function trackMeta(eventName, params) {
    if (typeof fbq === 'function') {
      var eid = eventName + '_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      fbq('trackCustom', eventName, params || {}, { eventID: eid });
    }
    if (typeof gtag === 'function') {
      try {
        var ga = {};
        for (var k in (params || {})) {
          if (k === 'email' || k === 'customer_name' || k === 'phone') continue; // never send PII to GA4
          ga[k] = params[k];
        }
        gtag('event', eventName, ga);
      } catch (e) {}
    }
  }

  function extractPricing(cls) {
    var p = cls.price || {};
    var det = (p.details && p.details[0]) || {};
    var dailyRate = det.base_daily_price ? parseFloat(det.base_daily_price.amount) : null;
    var dailyDisplay = det.base_daily_price ? det.base_daily_price.amount_for_display : null;
    var weeklyRate = det.base_weekly_price ? parseFloat(det.base_weekly_price.amount) : null;
    var weeklyDisplay = det.base_weekly_price ? det.base_weekly_price.amount_for_display : null;
    var monthlyRate = det.base_monthly_price ? parseFloat(det.base_monthly_price.amount) : null;
    var monthlyDisplay = det.base_monthly_price ? det.base_monthly_price.amount_for_display : null;
    var totalDays = p.total_days || det.total_days || 1;
    var baseTotal = p.base_price ? parseFloat(p.base_price.amount) : null;
    var totalWithTax = p.base_price_with_taxes ? parseFloat(p.base_price_with_taxes.amount) : null;
    var totalDisplay = p.base_price_with_taxes ? p.base_price_with_taxes.amount_for_display : null;
    var taxAmount = (totalWithTax != null && baseTotal != null) ? totalWithTax - baseTotal : null;
    var dist = cls.distance_limits || {};

    var hqDays = det.days || 0;
    var hqWeeks = det.weeks || 0;
    var hqMonths = det.months || 0;
    var rateType = hqMonths > 0 ? 'monthly' : hqWeeks > 0 ? 'weekly' : 'daily';

    var rateSummaryParts = [];
    if (hqMonths > 0) rateSummaryParts.push(hqMonths + (hqMonths === 1 ? ' Month' : ' Months'));
    if (hqWeeks > 0) rateSummaryParts.push(hqWeeks + (hqWeeks === 1 ? ' Week' : ' Weeks'));
    if (hqDays > 0) rateSummaryParts.push(hqDays + (hqDays === 1 ? ' Day' : ' Days'));
    if (!rateSummaryParts.length) rateSummaryParts.push(totalDays + (totalDays === 1 ? ' Day' : ' Days'));

    var dailyPortion = det.daily_price ? parseFloat(det.daily_price.amount) : 0;
    var dailyPortionDisplay = det.daily_price ? det.daily_price.amount_for_display : null;
    var weeklyPortion = det.weekly_price ? parseFloat(det.weekly_price.amount) : 0;
    var weeklyPortionDisplay = det.weekly_price ? det.weekly_price.amount_for_display : null;
    var monthlyPortion = det.monthly_price ? parseFloat(det.monthly_price.amount) : 0;
    var monthlyPortionDisplay = det.monthly_price ? det.monthly_price.amount_for_display : null;

    return {
      dailyRate: dailyRate, dailyDisplay: dailyDisplay || (dailyRate != null ? money(dailyRate) : '—'),
      weeklyRate: weeklyRate, weeklyDisplay: weeklyDisplay || (weeklyRate != null ? money(weeklyRate) : '—'),
      monthlyRate: monthlyRate, monthlyDisplay: monthlyDisplay || (monthlyRate != null ? money(monthlyRate) : '—'),
      rateType: rateType,
      hqDays: hqDays, hqWeeks: hqWeeks, hqMonths: hqMonths,
      rateSummaryParts: rateSummaryParts,
      dailyPortion: dailyPortion, dailyPortionDisplay: dailyPortionDisplay,
      weeklyPortion: weeklyPortion, weeklyPortionDisplay: weeklyPortionDisplay,
      monthlyPortion: monthlyPortion, monthlyPortionDisplay: monthlyPortionDisplay,
      totalDays: totalDays, baseTotal: baseTotal,
      totalWithTax: totalWithTax, totalDisplay: totalDisplay || (totalWithTax != null ? money(totalWithTax) : '—'),
      taxAmount: taxAmount,
      milesPerDay: dist.distance_limit_per_day || dist.distance_allowed || null,
      mileUnit: dist.distance_unit || 'miles',
      extraMilePrice: (dist.distance_extra_price_with_tax || dist.distance_extra_price || {}).amount ? parseFloat((dist.distance_extra_price_with_tax || dist.distance_extra_price).amount) : null,
      available: cls.availability ? cls.availability.quantity : null,
      selectable: cls.availability ? cls.availability.selectable !== false : true,
      vehicleLabel: (cls.vehicle_class || {}).label || '',
      vehicleDesc: (cls.vehicle_class || {}).short_description || '',
      vehicleImage: (cls.vehicle_class || {}).image || '',
      totalForPeriod: p.base_price ? p.base_price.amount_for_display : null,
    };
  }

  /* ── Custom Dropdown ── */
  function ArkSelect(wrap, placeholder, icon) {
    this.wrap = wrap; this.value = ''; this.label = ''; this.options = [];
    this._build(placeholder || 'Select', icon || '');
  }
  ArkSelect.prototype._build = function (ph, icon) {
    this.wrap.classList.add('ark-sel');
    var iconSvg = icon === 'clock' ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
      : icon === 'pin' ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>'
      : '';
    this.wrap.innerHTML =
      '<button type="button" class="ark-sel__display" data-sel-btn>' +
        (iconSvg ? '<span class="ark-sel__icon">' + iconSvg + '</span>' : '') +
        '<span data-sel-text class="ark-sel__text">' + ph + '</span>' +
        '<svg class="ark-sel__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</button>' +
      '<div class="ark-sel__drop" hidden><div class="ark-sel__list" data-sel-list></div></div>';
    var self = this;
    $(this.wrap, '[data-sel-btn]').addEventListener('click', function (e) { e.stopPropagation(); self._toggle(); });
    document.addEventListener('click', function () { self._close(); });
    this.wrap.addEventListener('click', function (e) { e.stopPropagation(); });
  };
  ArkSelect.prototype.setOptions = function (opts) {
    this.options = opts;
    var list = $(this.wrap, '[data-sel-list]'); list.innerHTML = '';
    var self = this;
    opts.forEach(function (o) {
      var item = document.createElement('button');
      item.type = 'button'; item.className = 'ark-sel__item';
      item.textContent = o.label; item.setAttribute('data-val', o.value);
      if (o.value === self.value) item.classList.add('ark-sel__item--active');
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        self.value = o.value; self.label = o.label;
        $(self.wrap, '[data-sel-text]').textContent = o.label;
        self.wrap.classList.add('ark-sel--has-value');
        $$(self.wrap, '.ark-sel__item').forEach(function (x) { x.classList.toggle('ark-sel__item--active', x.getAttribute('data-val') === o.value); });
        self._close();
      });
      list.appendChild(item);
    });
  };
  ArkSelect.prototype._toggle = function () { var d = $(this.wrap, '.ark-sel__drop'); d.hidden = !d.hidden; };
  ArkSelect.prototype._close = function () { $(this.wrap, '.ark-sel__drop').hidden = true; };
  ArkSelect.prototype.getValue = function () { return this.value; };
  ArkSelect.prototype.reset = function (ph) { this.value = ''; this.label = ''; $(this.wrap, '[data-sel-text]').textContent = ph || 'Select'; this.wrap.classList.remove('ark-sel--has-value'); };
  ArkSelect.prototype.selectFirst = function () { if (this.options.length) { var o = this.options[0]; this.value = o.value; this.label = o.label; $(this.wrap, '[data-sel-text]').textContent = o.label; this.wrap.classList.add('ark-sel--has-value'); } };
  ArkSelect.prototype.selectByValue = function (v) {
    var self = this;
    this.options.forEach(function (o) { if (String(o.value) === String(v)) { self.value = o.value; self.label = o.label; $(self.wrap, '[data-sel-text]').textContent = o.label; self.wrap.classList.add('ark-sel--has-value'); } });
  };

  function to12h(t24) {
    var parts = t24.split(':');
    var h = parseInt(parts[0], 10);
    var m = parts[1] || '00';
    var ampm = h >= 12 ? 'PM' : 'AM';
    var h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return h12 + ':' + m + ' ' + ampm;
  }

  /* ── Calendar ── */
  function ArkCal(wrap, onChange) {
    this.wrap = wrap; this.onChange = onChange; this.value = '';
    this.minDate = null; this.blockedSet = {};
    this.viewYear = new Date().getFullYear(); this.viewMonth = new Date().getMonth();
    this._build();
  }
  ArkCal.prototype._build = function () {
    this.wrap.classList.add('ark-cal');
    this.wrap.innerHTML =
      '<button type="button" class="ark-cal__display" data-cal-btn><span data-cal-text>Select date</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></button>' +
      '<div class="ark-cal__drop" hidden><div class="ark-cal__head"><button type="button" data-cal-prev class="ark-cal__arrow">&lsaquo;</button><span data-cal-title class="ark-cal__month"></span><button type="button" data-cal-next class="ark-cal__arrow">&rsaquo;</button></div><div class="ark-cal__days">Su Mo Tu We Th Fr Sa</div><div class="ark-cal__grid" data-cal-grid></div><div class="ark-cal__note" style="margin-top:10px;padding-top:9px;border-top:1px solid rgba(127,127,127,0.15);font-size:0.66rem;letter-spacing:0.03em;opacity:0.5;text-align:center;">Weekend dates book out fast — secure yours now.</div></div>';
    var self = this;
    $(this.wrap, '[data-cal-btn]').addEventListener('click', function (e) { e.stopPropagation(); self._toggle(); });
    $(this.wrap, '[data-cal-prev]').addEventListener('click', function (e) { e.stopPropagation(); self._nav(-1); });
    $(this.wrap, '[data-cal-next]').addEventListener('click', function (e) { e.stopPropagation(); self._nav(1); });
    document.addEventListener('click', function () { self._close(); });
    this.wrap.addEventListener('click', function (e) { e.stopPropagation(); });
  };
  ArkCal.prototype.setMin = function (ds) { this.minDate = ds ? new Date(ds + 'T00:00:00') : null; };
  ArkCal.prototype.setBlocked = function (arr) { this.blockedSet = {}; var s = this; (arr || []).forEach(function (d) { s.blockedSet[String(d).slice(0, 10)] = true; }); };
  ArkCal.prototype._toggle = function () { var d = $(this.wrap, '.ark-cal__drop'); if (!d.hidden) { d.hidden = true; return; } if (this.value) { var p = this.value.split('-'); this.viewYear = +p[0]; this.viewMonth = +p[1] - 1; } else { var now = new Date(); this.viewYear = now.getFullYear(); this.viewMonth = now.getMonth(); } d.hidden = false; this._render(); };
  ArkCal.prototype._close = function () { $(this.wrap, '.ark-cal__drop').hidden = true; };
  ArkCal.prototype._nav = function (dir) { this.viewMonth += dir; if (this.viewMonth > 11) { this.viewMonth = 0; this.viewYear++; } if (this.viewMonth < 0) { this.viewMonth = 11; this.viewYear--; } this._render(); };
  ArkCal.prototype._render = function () {
    var M = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    $(this.wrap, '[data-cal-title]').textContent = M[this.viewMonth] + ' ' + this.viewYear;
    var grid = $(this.wrap, '[data-cal-grid]'); grid.innerHTML = '';
    var first = new Date(this.viewYear, this.viewMonth, 1); var startDay = first.getDay();
    var dim = new Date(this.viewYear, this.viewMonth + 1, 0).getDate(); var today = fmtDate(new Date()); var self = this;
    for (var i = 0; i < startDay; i++) { var bl = document.createElement('span'); bl.className = 'ark-cal__cell ark-cal__cell--empty'; grid.appendChild(bl); }
    for (var d = 1; d <= dim; d++) {
      var ds = this.viewYear + '-' + pad(this.viewMonth + 1) + '-' + pad(d);
      var c = document.createElement('button'); c.type = 'button'; c.className = 'ark-cal__cell'; c.textContent = d; c.setAttribute('data-date', ds);
      if ((this.minDate && new Date(ds + 'T00:00:00') < this.minDate) || ds < today || this.blockedSet[ds]) { c.disabled = true; c.classList.add('ark-cal__cell--disabled'); }
      if (ds === this.value) c.classList.add('ark-cal__cell--selected');
      if (ds === today) c.classList.add('ark-cal__cell--today');
      (function (dateStr) { c.addEventListener('click', function (e) { e.stopPropagation(); self.value = dateStr; $(self.wrap, '[data-cal-text]').textContent = fmtDisplay(dateStr); self.wrap.classList.add('ark-cal--has-value'); self._close(); self._render(); if (self.onChange) self.onChange(dateStr); }); })(ds);
      grid.appendChild(c);
    }
  };
  ArkCal.prototype.getValue = function () { return this.value; };
  ArkCal.prototype.reset = function () { this.value = ''; $(this.wrap, '[data-cal-text]').textContent = 'Select date'; this.wrap.classList.remove('ark-cal--has-value'); };

  /* ── Popup ── */
  function Popup(root) {
    this.root = root;
    this.inline = root.getAttribute('data-pdp-inline') === 'true';
    this.apiBase = (root.getAttribute('data-api-base') || '').replace(/\/$/, '');
    this.brandId = parseInt(root.getAttribute('data-brand-id') || '1', 10) || 1;
    this.payMethodId = root.getAttribute('data-payment-method-id') || '';
    this.payRedirect = root.getAttribute('data-payment-redirect') || '';
    this.fallbackMap = parseFallback(root.getAttribute('data-fallback-json'));
    this.pickCal = null; this.retCal = null;
    this.pickTime = null; this.retTime = null;
    this.pickLoc = null; this.retLoc = null;
    this.st = {}; this._bind();
  }

  Popup.prototype._reset = function () {
    return { step: 1, vcId: null, vName: '', vImage: '', handle: '', pUrl: '',
      datesConfig: null, blockedDays: [], datesResponse: null, datesQuery: {},
      applicableClasses: [], selectedClassPricing: null,
      allCharges: [], customerFields: [], customerId: null, paymentLink: null,
      days: 1, dailyRate: null, dailyDisplay: '—', totalWithTax: null, totalDisplay: '—',
      weeklyRate: null, weeklyDisplay: '—', monthlyRate: null, monthlyDisplay: '—',
      rateType: 'daily', hqDays: 0, hqWeeks: 0, hqMonths: 0,
      taxAmount: null, milesPerDay: null, mileUnit: 'miles', extraMilePrice: null,
      baseTotal: null, baseTotalDisplay: '—',
      pickLocLabel: '', retLocLabel: '', pickLocCustom: false, retLocCustom: false,
      custFirstName: '', custLastName: '', custEmail: '', custPhone: '',
      couponCode: '', couponDiscount: null, couponLabel: '' };
  };

  Popup.prototype._bind = function () {
    var self = this;
    $$(this.root, '[data-ark-close]').forEach(function (el) { el.addEventListener('click', function () { self.close(); }); });
    $(this.root, '[data-ark-step1]').addEventListener('click', function () { self.submitDates(); });
    $(this.root, '[data-ark-step3]').addEventListener('click', function () { self.submitCustomer(); });
    $(this.root, '[data-ark-step4]').addEventListener('click', function () { self.submitConfirm(); });
    $$(this.root, '[data-ark-back]').forEach(function (b) { b.addEventListener('click', function () { if (self.st.step > 1) self.goToStep(self.st.step - 1); }); });
    var sb = $(this.root, '[data-ark-side-continue]');
    if (sb) sb.addEventListener('click', function () {
      if (self.st.step === 1) self.submitDates();
      else if (self.st.step === 3) self.submitCustomer();
      else if (self.st.step === 4) self.submitConfirm();
    });
    var sdone = $(this.root, '[data-ark-success-done]');
    if (sdone) sdone.addEventListener('click', function () {
      if (self.inline) self._restartFromSuccess();
      else self.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.inline && !self.root.hidden) self.close();
    });
    var pw = $(this.root, '[data-ark-pickup-date]');
    var rw = $(this.root, '[data-ark-return-date]');
    if (pw) this.pickCal = new ArkCal(pw, function (v) { if (self.retCal) self.retCal.setMin(v); });
    if (rw) this.retCal = new ArkCal(rw, null);
    var ptw = $(this.root, '[data-ark-pickup-time]');
    var rtw = $(this.root, '[data-ark-return-time]');
    if (ptw) this.pickTime = new ArkSelect(ptw, 'Select time', 'clock');
    if (rtw) this.retTime = new ArkSelect(rtw, 'Select time', 'clock');
    var plw = $(this.root, '[data-ark-pickup-loc]');
    var rlw = $(this.root, '[data-ark-return-loc]');
    if (plw) this.pickLoc = new ArkSelect(plw, 'Select location', 'pin');
    if (rlw) this.retLoc = new ArkSelect(rlw, 'Select location', 'pin');
  };

  Popup.prototype._api = function (path, opts) {
    opts = opts || {};
    return fetch(this.apiBase + path, { method: opts.method || 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: opts.body ? JSON.stringify(opts.body) : undefined }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  };

  Popup.prototype._err = function (n, msg) { var el = $(this.root, '[data-step="' + n + '"] [data-ark-error]'); if (el) { el.textContent = msg; el.classList.remove('ark-popup__error--hidden'); } };
  Popup.prototype._noErr = function (n) { var el = $(this.root, '[data-step="' + n + '"] [data-ark-error]'); if (el) { el.textContent = ''; el.classList.add('ark-popup__error--hidden'); } };
  Popup.prototype._load = function (n, on) { var el = $(this.root, '[data-step="' + n + '"] [data-ark-loader]'); if (el) el.classList.toggle('ark-popup__loader--hidden', !on); };

  Popup.prototype.open = function (pd) {
    if (!this.apiBase) { alert('Booking API URL is not configured.'); return; }
    var vcid = pd.vehicleClassId ? parseInt(pd.vehicleClassId, 10) : null;
    if (!vcid && pd.handle && this.fallbackMap[pd.handle] != null) vcid = parseInt(this.fallbackMap[pd.handle], 10);
    if (!vcid) {
      if (this.inline) { alert('This vehicle is not set up for online booking yet. Add vehicle_class_id or fallback mapping.'); return; }
      if (pd.productUrl) window.location.href = pd.productUrl;
      return;
    }

    this.st = this._reset();
    this._abandonSent = false;
    this.st.vcId = vcid; this.st.vName = pd.name || ''; this.st.vImage = pd.image || '';
    this.st.handle = pd.handle || ''; this.st.pUrl = pd.productUrl || '';
    var initPrice = pd.price ? parseFloat(String(pd.price).replace(/[^0-9.]/g, '')) : null;
    if (initPrice && !isNaN(initPrice)) {
      this.st.dailyRate = initPrice;
      this.st.dailyDisplay = money(initPrice);
    }

    if (!this.inline) {
      this.root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    var sn = $(this.root, '[data-ark-side-name]'); if (sn) sn.textContent = this.st.vName;
    var img = $(this.root, '[data-ark-side-img]'); if (img) { img.src = this.st.vImage; img.alt = this.st.vName; }
    if (this.pickCal) this.pickCal.reset(); if (this.retCal) this.retCal.reset();
    this._sidebar(); this.goToStep(1); this._initStep1();
  };

  Popup.prototype.close = function () {
    this._fireAbandon();
    if (this.inline) {
      document.documentElement.style.overflow = '';
      return;
    }
    if (this.st && this.st.totalWithTax != null && !this.st.converted) this._fireDemand(false);
    this.root.hidden = true;
    document.documentElement.style.overflow = '';
    var f = $(this.root, '[data-ark-pay-iframe]');
    if (f) f.src = 'about:blank';
  };

  Popup.prototype.goToStep = function (n) {
    this.st.step = n;
    if (n === 2) this._armDemand();
    if (n === 3) this._armAbandon();
    $$(this.root, '[data-ark-nav]').forEach(function (el) { el.classList.toggle('ark-popup__nav-item--active', parseInt(el.getAttribute('data-ark-nav')) === n); });
    $$(this.root, '[data-step]').forEach(function (el) { el.hidden = parseInt(el.getAttribute('data-step'), 10) !== n; });
    var sb = $(this.root, '[data-ark-side-continue]'); if (sb) sb.style.display = n === 2 ? 'none' : '';
    var nav = $(this.root, '.ark-popup__nav');
    if (nav) nav.hidden = n === 5;
    var aside = $(this.root, '.ark-popup__right');
    if (aside) aside.hidden = n === 5;
    this.root.classList.toggle('ark-popup--step-success', n === 5);
  };

  Popup.prototype._restartFromSuccess = function () {
    var r = this.root;
    this.open({
      vehicleClassId: r.getAttribute('data-vehicle-class-id') || '',
      name: r.getAttribute('data-vehicle-name') || '',
      image: r.getAttribute('data-vehicle-image') || '',
      handle: r.getAttribute('data-product-handle') || '',
      productUrl: r.getAttribute('data-product-url') || '',
      price: r.getAttribute('data-vehicle-price') || ''
    });
  };

  Popup.prototype._showReservationSuccess = function () {
    var self = this;
    var icon = $(this.root, '[data-ark-success-icon]');
    if (icon) icon.classList.remove('ark-popup__success-visual--play');
    this.goToStep(5);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var ic = $(self.root, '[data-ark-success-icon]');
        if (ic) {
          void ic.offsetWidth;
          ic.classList.add('ark-popup__success-visual--play');
        }
        var title = $(self.root, '[data-step="5"] .ark-popup__title--success');
        if (title && title.focus) title.focus();
      });
    });
  };

  Popup.prototype._sidebar = function () {
    var s = this.st;
    var r = this.root;
    function T(sel, val) { var e = $(r, sel); if (e) e.textContent = val; }
    var pickD = this.pickCal ? this.pickCal.getValue() : '';
    var retD = this.retCal ? this.retCal.getValue() : '';
    T('[data-ark-side-period]', pickD && retD ? fmtDisplay(pickD) + ' – ' + fmtDisplay(retD) : '—');
    T('[data-ark-side-days]', s.days ? s.days + (s.days === 1 ? ' day' : ' days') : '');
    var rateLabel = '—';
    if (s.rateType === 'monthly' && s.monthlyRate != null) rateLabel = s.monthlyDisplay + '/month';
    else if (s.rateType === 'weekly' && s.weeklyRate != null) rateLabel = s.weeklyDisplay + '/week';
    else if (s.dailyRate != null) rateLabel = s.dailyDisplay + '/day';
    T('[data-ark-side-daily]', rateLabel);
    T('[data-ark-side-miles]', s.milesPerDay != null ? s.milesPerDay + ' ' + s.mileUnit + '/day' : '—');
    var note = s.extraMilePrice && s.extraMilePrice > 0 ? money(s.extraMilePrice) + ' per extra ' + (s.mileUnit === 'miles' ? 'mile' : s.mileUnit) : '';
    T('[data-ark-side-mile-note]', note);
    T('[data-ark-side-tax]', s.taxAmount != null ? money(s.taxAmount) : '—');
    T('[data-ark-side-total]', s.totalDisplay);
  };

  /* Step 1: Dates */
  Popup.prototype._initStep1 = function () {
    var self = this; this._noErr(1); this._load(1, true);
    Promise.all([
      this._api('/api/reservation/dates-config?brand_id=' + this.brandId),
      this._api('/api/blocked-days'),
    ]).then(function (res) {
      self._load(1, false);
      var cfg = (res[0].data && res[0].data.data) || res[0].data || {};
      self.st.datesConfig = cfg;
      var minStart = (cfg.defaults && cfg.defaults.min_start_date) || fmtDate(new Date());
      if (self.pickCal) self.pickCal.setMin(minStart);
      if (self.retCal) self.retCal.setMin(minStart);
      var blocked = (res[1].data && res[1].data.data) || [];
      if (Array.isArray(blocked)) { self.st.blockedDays = blocked.map(function (b) { return typeof b === 'string' ? b : b.date || ''; }); if (self.pickCal) self.pickCal.setBlocked(self.st.blockedDays); if (self.retCal) self.retCal.setBlocked(self.st.blockedDays); }
      var timeOpts = [];
      for (var h = 8; h <= 20; h++) {
        timeOpts.push({ value: pad(h) + ':00', label: to12h(pad(h) + ':00') });
        timeOpts.push({ value: pad(h) + ':30', label: to12h(pad(h) + ':30') });
      }
      if (self.pickTime) { self.pickTime.setOptions(timeOpts); self.pickTime.selectByValue('10:00'); }
      if (self.retTime) { self.retTime.setOptions(timeOpts); self.retTime.selectByValue('10:00'); }

      var pickUpLocs = cfg.pick_up_locations || {};
      var returnLocs = cfg.return_locations || pickUpLocs;
      var pickOpts = []; var retOpts = [];
      Object.keys(pickUpLocs).forEach(function (id) {
        pickOpts.push({ value: id, label: id === 'custom' ? 'Other (Custom Address)' : pickUpLocs[id] });
      });
      Object.keys(returnLocs).forEach(function (id) {
        retOpts.push({ value: id, label: id === 'custom' ? 'Other (Custom Address)' : returnLocs[id] });
      });

      var pickCustom = $(self.root, '[data-ark-pickup-custom]');
      var retCustom = $(self.root, '[data-ark-return-custom]');
      function onPickLocChange() {
        var v = self.pickLoc ? self.pickLoc.getValue() : '';
        if (pickCustom) pickCustom.classList.toggle('ark-popup__custom-addr--hidden', v !== 'custom');
      }
      function onRetLocChange() {
        var v = self.retLoc ? self.retLoc.getValue() : '';
        if (retCustom) retCustom.classList.toggle('ark-popup__custom-addr--hidden', v !== 'custom');
      }

      if (self.pickLoc) {
        self.pickLoc.setOptions(pickOpts);
        if (pickOpts.length && pickOpts[0].value !== 'custom') self.pickLoc.selectFirst();
        var origPickToggle = self.pickLoc._close;
        self.pickLoc._close = function () { origPickToggle.call(self.pickLoc); onPickLocChange(); };
      }
      if (self.retLoc) {
        self.retLoc.setOptions(retOpts);
        if (retOpts.length && retOpts[0].value !== 'custom') self.retLoc.selectFirst();
        var origRetToggle = self.retLoc._close;
        self.retLoc._close = function () { origRetToggle.call(self.retLoc); onRetLocChange(); };
      }
    }).catch(function () { self._load(1, false); self._err(1, 'Network error.'); });
  };

  Popup.prototype.submitDates = function () {
    this._noErr(1);
    var pickD = this.pickCal ? this.pickCal.getValue() : '';
    var retD = this.retCal ? this.retCal.getValue() : '';
    if (!pickD || !retD) { this._err(1, 'Please select pick-up and return dates.'); return; }
    if (retD <= pickD) { this._err(1, 'Return date must be after pick-up.'); return; }
    var pickL = this.pickLoc ? this.pickLoc.getValue() : '';
    if (!pickL) { this._err(1, 'Please select a pick-up location.'); return; }
    var retL = (this.retLoc ? this.retLoc.getValue() : '') || pickL;
    var pickT = this.pickTime ? this.pickTime.getValue() : '10:00';
    var retT = this.retTime ? this.retTime.getValue() : '10:00';
    if (!pickT) { this._err(1, 'Please select a pick-up time.'); return; }
    if (!retT) { this._err(1, 'Please select a return time.'); return; }

    var pickCustomAddr = $(this.root, '[data-ark-pickup-custom]');
    var retCustomAddr = $(this.root, '[data-ark-return-custom]');
    if (pickL === 'custom' && pickCustomAddr && !pickCustomAddr.value.trim()) { this._err(1, 'Please enter a pick-up address.'); return; }
    if (retL === 'custom' && retCustomAddr && !retCustomAddr.value.trim()) { this._err(1, 'Please enter a return address.'); return; }

    var body = { brand_id: this.brandId, pick_up_date: pickD, return_date: retD, pick_up_time: pickT, return_time: retT };
    if (pickL === 'custom') { body.pick_up_location_custom = pickCustomAddr.value.trim(); }
    else { body.pick_up_location = parseInt(pickL); }
    if (retL === 'custom') { body.return_location_custom = retCustomAddr.value.trim(); }
    else { body.return_location = parseInt(retL); }
    this.st.datesQuery = body;
    this.st.days = Math.max(1, Math.round((new Date(retD + 'T00:00:00') - new Date(pickD + 'T00:00:00')) / 86400000));
    this.st.pickLocLabel = this.pickLoc ? this.pickLoc.label : '';
    this.st.retLocLabel = this.retLoc ? this.retLoc.label : this.st.pickLocLabel;
    this.st.pickLocCustom = pickL === 'custom';
    this.st.retLocCustom = retL === 'custom';

    var self = this; this._load(1, true);
    this._api('/api/reservation/dates', { method: 'POST', body: body }).then(function (r) {
      self._load(1, false);
      if (!r.ok) { var msg = r.data && (r.data.message || (r.data.errors && r.data.errors.error_message)); self._err(1, (typeof msg === 'string' ? msg : JSON.stringify(msg)) || 'Dates not available.'); return; }
      var data = (r.data && r.data.data) || r.data;
      self.st.datesResponse = data;
      self.st.applicableClasses = data.applicable_classes || [];
      trackMeta('Booking_Step_1_Dates', { vehicle_name: self.st.vName, pickup_date: self.st.datesQuery.pick_up_date, return_date: self.st.datesQuery.return_date, days: self.st.days });
      self._renderVehicles();
    }).catch(function () { self._load(1, false); self._err(1, 'Network error.'); });
  };

  /* Step 2: Vehicles */
  Popup.prototype._renderVehicles = function () {
    var container = $(this.root, '[data-ark-vehicles]');
    container.innerHTML = '';
    var self = this;
    var classes = this.st.applicableClasses;
    var selectedId = this.st.vcId;

    var match = classes.find(function (c) { return parseInt(c.vehicle_class_id) === selectedId; });
    if (match) this._addVehicleCard(container, match, true);

    var others = classes.filter(function (c) { return parseInt(c.vehicle_class_id) !== selectedId; });
    if (others.length) {
      var h = document.createElement('p');
      h.className = 'ark-popup__section-label';
      h.textContent = 'Other Available Vehicles';
      container.appendChild(h);
      others.forEach(function (c) { self._addVehicleCard(container, c, false); });
    }
    if (this.inline && match) {
      var _ab = container.querySelector('.ark-popup__vcard--selected .ark-popup__vcard-btn');
      if (_ab && !_ab.disabled) { _ab.click(); return; }
    }
    this.goToStep(2);
  };

  Popup.prototype._addVehicleCard = function (container, cls, isSelected) {
    var pricing = extractPricing(cls);
    var card = document.createElement('div');
    card.className = 'ark-popup__vcard' + (isSelected ? ' ark-popup__vcard--selected' : '');
    var avail = pricing.available;
    var canBook = pricing.selectable && avail !== 0;
    var imgSrc = pricing.vehicleImage || this.st.vImage || '';
    card.innerHTML =
      '<div class="ark-popup__vcard-row">' +
        (imgSrc ? '<div class="ark-popup__vcard-img-wrap"><img src="' + imgSrc + '" alt="" class="ark-popup__vcard-img" width="160" height="90" loading="lazy"></div>' : '') +
        '<div class="ark-popup__vcard-info">' +
          '<h3 class="ark-popup__vcard-name">' + (pricing.vehicleLabel || this.st.vName) + '</h3>' +
          '<p class="ark-popup__vcard-desc">' + (pricing.vehicleDesc || '').replace(/<[^>]+>/g, '').slice(0, 120) + '</p>' +
        '</div>' +
        '<div class="ark-popup__vcard-price">' +
          (function () {
            var rType = pricing.rateType;
            var mainRate, perLabel, equivNote = '';
            if (rType === 'monthly' && pricing.monthlyRate != null) {
              mainRate = pricing.monthlyDisplay; perLabel = '/month';
              if (pricing.dailyRate != null) equivNote = '<p class="ark-popup__vcard-equiv">≈ ' + money(pricing.monthlyRate / 30) + '/day</p>';
            } else if (rType === 'weekly' && pricing.weeklyRate != null) {
              mainRate = pricing.weeklyDisplay; perLabel = '/week';
              if (pricing.dailyRate != null) equivNote = '<p class="ark-popup__vcard-equiv">≈ ' + money(pricing.weeklyRate / 7) + '/day</p>';
            } else {
              mainRate = pricing.dailyDisplay; perLabel = '/day';
            }
            return '<span class="ark-popup__vcard-daily">' + mainRate + '</span><span class="ark-popup__vcard-per"> ' + perLabel + '</span>' + equivNote;
          })() +
          '<p class="ark-popup__vcard-total">' + pricing.totalDisplay + ' total for ' + pricing.rateSummaryParts.join(' + ') + '</p>' +
          '<p class="ark-popup__vcard-excl">Excl. taxes &amp; insurance(s)</p>' +
        '</div>' +
      '</div>' +
      '<div class="ark-popup__vcard-actions">' +
        (canBook ? '<button type="button" class="ark-popup__btn ark-popup__btn--primary ark-popup__vcard-btn">' + (isSelected ? 'Continue with this Vehicle' : 'Rent this Vehicle') + '</button>'
                 : '<button type="button" class="ark-popup__btn ark-popup__vcard-btn ark-popup__btn--disabled" disabled>Not Available — Contact Us</button>') +
      '</div>';

    var self = this;
    var btn = card.querySelector('.ark-popup__vcard-btn');
    if (btn && canBook) {
      btn.addEventListener('click', function () {
        self.st.vcId = parseInt(cls.vehicle_class_id);
        self.st.selectedClassPricing = pricing;
        self.st.dailyRate = pricing.dailyRate;
        self.st.dailyDisplay = pricing.dailyDisplay;
        self.st.weeklyRate = pricing.weeklyRate;
        self.st.weeklyDisplay = pricing.weeklyDisplay;
        self.st.monthlyRate = pricing.monthlyRate;
        self.st.monthlyDisplay = pricing.monthlyDisplay;
        self.st.rateType = pricing.rateType;
        self.st.hqDays = pricing.hqDays;
        self.st.hqWeeks = pricing.hqWeeks;
        self.st.hqMonths = pricing.hqMonths;
        self.st.totalWithTax = pricing.totalWithTax;
        self.st.totalDisplay = pricing.totalDisplay;
        self.st.taxAmount = pricing.taxAmount;
        self.st.baseTotal = pricing.baseTotal;
        self.st.baseTotalDisplay = pricing.totalForPeriod || money(pricing.baseTotal);
        self.st.milesPerDay = pricing.milesPerDay;
        self.st.mileUnit = pricing.mileUnit;
        self.st.extraMilePrice = pricing.extraMilePrice;
        self.st.vName = pricing.vehicleLabel || self.st.vName;
        var sn2 = $(self.root, '[data-ark-side-name]'); if (sn2) sn2.textContent = self.st.vName;
        if (pricing.vehicleImage) { var img2 = $(self.root, '[data-ark-side-img]'); if (img2) img2.src = pricing.vehicleImage; }
        self.st.datesQuery.vehicle_class_id = self.st.vcId;
        trackMeta('Booking_Step_2_Vehicle', { vehicle_name: self.st.vName, vehicle_class_id: self.st.vcId, daily_rate: self.st.dailyRate, days: self.st.days, total: self.st.totalDisplay , value: (self.st.totalWithTax != null ? self.st.totalWithTax : 0), currency: 'USD' });
        self._sidebar();
        self._loadCustomer();
      });
    }
    container.appendChild(card);
  };

  /* Step 3: Customer */
  Popup.prototype._loadCustomer = function () {
    this._noErr(3);
    var cust = $(this.root, '[data-ark-customer-fields]');
    cust.innerHTML =
      '<div class="ark-popup__cust-grid">' +
        '<label class="ark-popup__field"><span class="ark-popup__label">First Name *</span><input class="ark-popup__input" type="text" data-cf="first_name" required placeholder="John"></label>' +
        '<label class="ark-popup__field"><span class="ark-popup__label">Last Name *</span><input class="ark-popup__input" type="text" data-cf="last_name" required placeholder="Doe"></label>' +
      '</div>' +
      '<div class="ark-popup__cust-grid">' +
        '<label class="ark-popup__field"><span class="ark-popup__label">Phone Number *</span><input class="ark-popup__input" type="tel" data-cf="phone_number" required placeholder="(786) 555-0100"></label>' +
        '<label class="ark-popup__field"><span class="ark-popup__label">Email Address *</span><input class="ark-popup__input" type="email" data-cf="email" required placeholder="john@example.com"></label>' +
      '</div>';

    var idTypeWrap = $(cust, '[data-ark-id-type]');
    if (idTypeWrap) {
      this.idTypeSel = new ArkSelect(idTypeWrap, 'Select ID type', '');
      this.idTypeSel.setOptions([
        { value: 'drivers_license', label: "Driver's License" },
        { value: 'passport', label: 'Passport' },
        { value: 'state_id', label: 'State ID' },
      ]);
      this.idTypeSel.selectFirst();
    }

    var fileInput = $(cust, '[data-ark-file-input]');
    var filePh = $(cust, '[data-ark-file-ph]');
    var filePrev = $(cust, '[data-ark-file-preview]');
    var fileName = $(cust, '[data-ark-file-name]');
    var fileRemove = $(cust, '[data-ark-file-remove]');
    var self = this;
    this.st.uploadedFile = null;

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) {
          var f = fileInput.files[0];
          self.st.uploadedFile = f;
          fileName.textContent = f.name + ' (' + (f.size / 1024 / 1024).toFixed(1) + ' MB)';
          filePh.style.display = 'none';
          filePrev.classList.remove('ark-popup__file-preview--hidden');
        }
      });
      fileRemove.addEventListener('click', function () {
        fileInput.value = '';
        self.st.uploadedFile = null;
        filePh.style.display = '';
        filePrev.classList.add('ark-popup__file-preview--hidden');
      });
    }

    this.goToStep(3);
  };

  Popup.prototype.submitCustomer = function () {
    this._noErr(3);
    var inputs = $$($(this.root, '[data-step="3"]'), '[data-cf]');
    var body = Object.assign({}, this.st.datesQuery);
    var missing = false;
    inputs.forEach(function (inp) {
      body[inp.getAttribute('data-cf')] = inp.value.trim();
      if (inp.required && !inp.value.trim()) missing = true;
    });
    if (this.idTypeSel) body.id_type = this.idTypeSel.getValue();
    body.contact_entity = 'person';
    body.full_name = (body.first_name || '') + ' ' + (body.last_name || '');
    body.field_2 = body.full_name;
    body.field_5 = body.full_name;
    body.field_8 = body.phone_number || '';
    body.field_9 = body.email || '';
    body.field_254 = body.driver_license || '';
    if (missing) { this._err(3, 'Please fill in all required fields.'); return; }
    this.st.custFirstName = body.first_name || '';
    this.st.custLastName = body.last_name || '';
    this.st.custEmail = body.email || '';
    this.st.custPhone = body.phone_number || '';
    var self = this; this._load(3, true);
    this._api('/api/reservation/customer', { method: 'POST', body: body }).then(function (r) {
      self._load(3, false);
      var hqFailed = !r.ok || (r.data && r.data.success === false);
      if (hqFailed) {
        var errMsg = (r.data && r.data.errors && r.data.errors.error_message) || (r.data && r.data.message) || 'Could not save customer.';
        self._err(3, errMsg); return;
      }
      var rd = r.data || {};
      var dd = rd.data || {};
      var cid = rd.customer_id || dd.customer_id || (dd.reservation && dd.reservation.customer_id) || (dd.customer && dd.customer.id) || rd.id;
      if (!cid) { self._err(3, 'Unexpected server response.'); return; }
      self.st.customerId = cid;
      self.st.crmCaptured = true;
      trackMeta('Booking_Step_3_Customer', { vehicle_name: self.st.vName, customer_name: self.st.custFirstName + ' ' + self.st.custLastName, email: self.st.custEmail, days: self.st.days, total: self.st.totalDisplay , value: (self.st.totalWithTax != null ? self.st.totalWithTax : 0), currency: 'USD' });
      self._enrichBookingAttempt(cid);
      self._notifyCrm();
      self._renderConfirm();
    }).catch(function () { self._load(3, false); self._err(3, 'Network error.'); });
  };

  /**
   * Fire-and-forget enrichment after the HQ customer is created at Step 3.
   * 1) Uploads the DL image (if attached) to HQ via /api/reservation/upload-dl.
   * 2) Adds a "Booking attempt" note to the contact in HQ via /api/reservation/note,
   *    so the team can see in HQ admin what booking the customer was building.
   * Failures are logged only — they never block the popup UX.
   */
  /**
   * Abandoned-booking capture: if a visitor types a valid phone number on the
   * Customer Information step but never presses Next, fire one beacon when they
   * leave the page, close the popup, or idle 10 minutes. Junk numbers are
   * filtered here AND server-side; a successful Step-3 submit disarms this.
   */
  Popup.prototype._armAbandon = function () {
    var self = this;
    if (this._abandonArmed) { this._resetAbandonIdle(); return; }
    this._abandonArmed = true;
    window.addEventListener('pagehide', function () { self._fireAbandon(); });
    var step3 = $(this.root, '[data-step="3"]');
    if (step3) step3.addEventListener('input', function () { self._resetAbandonIdle(); });
    this._resetAbandonIdle();
  };

  function arkAttrib() {
    var out = {};
    try { out = JSON.parse(localStorage.getItem('ark_utm') || '{}') || {}; } catch (e) { out = {}; }
    try {
      var m = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
      if (m) out.fbc_cookie = decodeURIComponent(m[1]);
      var p = document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/);
      if (p) out.fbp_cookie = decodeURIComponent(p[1]);
    } catch (e) {}
    return out;
  }

  Popup.prototype._resetAbandonIdle = function () {
    var self = this;
    if (this._abandonTimer) clearTimeout(this._abandonTimer);
    this._abandonTimer = setTimeout(function () { self._fireAbandon(); }, 600000);
  };

  /**
   * Anonymous demand signal — NO PII. Logs the shape of demand (car, plan-by-miles,
   * length, quoted total, overage, coupon, converted Y/N) to GA4 + Meta so we can see
   * what the market is asking for and our quote->convert rate, independent of whether
   * the visitor ever gives a phone. Fires once for an abandon; always on a conversion.
   */
  Popup.prototype._fireDemand = function (converted) {
    var s = this.st || {};
    if (!converted) {
      if (this._demandSent) return;
      if (s.totalWithTax == null) return; // only count demand once a real quote was shown
      this._demandSent = true;
    }
    trackMeta(converted ? 'PDP_Demand_Convert' : 'PDP_Demand_Abandon', {
      vehicle_name: s.vName || '',
      vehicle_class_id: s.vcId || '',
      days: s.days || 1,
      daily_rate: s.dailyRate || 0,
      included_miles: s.milesPerDay != null ? s.milesPerDay : 0,
      overage: s.extraMilePrice != null ? s.extraMilePrice : 0,
      coupon: s.couponCode || 'none',
      step: s.step || 0,
      converted: converted ? 1 : 0,
      value: (s.totalWithTax != null ? s.totalWithTax : 0),
      currency: 'USD'
    });
  };

  // Arm anonymous demand capture the moment a quote is shown (Step 2), so visitors who
  // leave before ever reaching the customer-info step are still counted (no PII).
  Popup.prototype._armDemand = function () {
    if (this._demandArmed) return;
    this._demandArmed = true;
    var self = this;
    window.addEventListener('pagehide', function () { if (!(self.st && self.st.converted)) self._fireDemand(false); });
  };

  Popup.prototype._fireAbandon = function () {
    this._fireDemand(false);
    if (this._abandonSent) return;
    if (this.st && this.st.crmCaptured) return;
    var step3 = this.root ? $(this.root, '[data-step="3"]') : null;
    if (!step3) return;
    var vals = {};
    $$(step3, '[data-cf]').forEach(function (inp) { vals[inp.getAttribute('data-cf')] = (inp.value || '').trim(); });
    var digits = (vals.phone_number || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length !== 10) return;
    if (/^(\d)\1{9}$/.test(digits) || digits === '1234567890' || digits === '0123456789' || digits === '9876543210') return;
    this._abandonSent = true;
    var pickD = this.pickCal ? this.pickCal.getValue() : '';
    var retD = this.retCal ? this.retCal.getValue() : '';
    var payload = JSON.stringify({
      key: 'ark_pdp_step3_2026',
      source: 'abandon',
      first_name: vals.first_name || '',
      last_name: vals.last_name || '',
      email: vals.email || '',
      phone: digits,
      vehicle: (this.st && this.st.vName) || '',
      pick_up: pickD,
      return_date: retD,
      page: window.location.pathname,
      utm: arkAttrib(),
      fbc: (arkAttrib().fbc_cookie || ''),
      fbp: (arkAttrib().fbp_cookie || ''),
      source_url: window.location.href
    });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon('https://ark-sales-dashboard.vercel.app/api/pdp-lead', new Blob([payload], { type: 'text/plain' }));
      } else {
        fetch('https://ark-sales-dashboard.vercel.app/api/pdp-lead', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true }).catch(function () {});
      }
    } catch (e) { /* never block UX */ }
  };

  /**
   * Fire-and-forget Step-3 capture to the Ark CRM: creates an Asana lead card
   * immediately so the SMS closer can engage even if the booking is abandoned
   * before confirmation. Never blocks or surfaces errors in the popup UX.
   */
  Popup.prototype._notifyCrm = function () {
    var s = this.st;
    try {
      var pickD = this.pickCal ? this.pickCal.getValue() : '';
      var retD = this.retCal ? this.retCal.getValue() : '';
      fetch('https://ark-sales-dashboard.vercel.app/api/pdp-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          key: 'ark_pdp_step3_2026',
          first_name: s.custFirstName || '',
          last_name: s.custLastName || '',
          email: s.custEmail || '',
          phone: s.custPhone || '',
          vehicle: s.vName || '',
          pick_up: pickD,
          return_date: retD,
          page: window.location.pathname,
          utm: arkAttrib(),
          fbc: (arkAttrib().fbc_cookie || ''),
          fbp: (arkAttrib().fbp_cookie || ''),
          source_url: window.location.href
        })
      }).catch(function () {});
    } catch (e) { /* never block booking */ }
  };

  Popup.prototype._enrichBookingAttempt = function (customerId) {
    var self = this;
    var s = this.st;
    if (!self.apiBase || !customerId) return;

    if (s.uploadedFile) {
      try {
        var fd = new FormData();
        fd.append('customer_id', String(customerId));
        fd.append('file', s.uploadedFile, s.uploadedFile.name || 'dl.bin');
        fetch(self.apiBase + '/api/reservation/upload-dl', { method: 'POST', body: fd })
          .then(function (r) { if (!r.ok) console.warn('[ark] DL upload failed', r.status); })
          .catch(function (e) { console.warn('[ark] DL upload error', e && e.message); });
      } catch (e) { console.warn('[ark] DL upload threw', e && e.message); }
    }

    try {
      var lines = [];
      lines.push('Booking attempt via Shopify popup');
      if (s.vName) lines.push('Vehicle: ' + s.vName);
      var pickD = self.pickCal ? self.pickCal.getValue() : '';
      var retD = self.retCal ? self.retCal.getValue() : '';
      var pickT = self.pickTime ? self.pickTime.getValue() : '';
      var retT = self.retTime ? self.retTime.getValue() : '';
      if (pickD || retD) lines.push('Dates: ' + (pickD || '?') + ' ' + (pickT || '') + ' -> ' + (retD || '?') + ' ' + (retT || ''));
      if (s.pickLocLabel) lines.push('Pickup: ' + s.pickLocLabel + (s.pickLocCustom ? ' (custom address)' : ''));
      if (s.retLocLabel && s.retLocLabel !== s.pickLocLabel) lines.push('Return: ' + s.retLocLabel + (s.retLocCustom ? ' (custom address)' : ''));
      if (s.days) lines.push('Days: ' + s.days);
      if (s.totalDisplay) lines.push('Estimated total: ' + s.totalDisplay);
      if (s.custPhone) lines.push('Phone: ' + s.custPhone);
      if (s.custEmail) lines.push('Email: ' + s.custEmail);

      fetch(self.apiBase + '/api/reservation/note', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: customerId, comment: lines.join('\n') }),
      })
        .then(function (r) { if (!r.ok) console.warn('[ark] note failed', r.status); })
        .catch(function (e) { console.warn('[ark] note error', e && e.message); });
    } catch (e) { console.warn('[ark] note threw', e && e.message); }
  };

  Popup.prototype._buildRateBreakdownLines = function () {
    var s = this.st;
    var pr = s.selectedClassPricing;
    if (!pr || pr.rateType === 'daily') {
      return '<div class="ark-popup__sum-line"><span>' + s.days + 'x Days @ ' + s.dailyDisplay + '</span><span>' + (s.baseTotalDisplay || '—') + '</span></div>';
    }
    var lines = '';
    if (pr.hqMonths > 0 && pr.monthlyRate != null) {
      lines += '<div class="ark-popup__sum-line"><span>' + pr.hqMonths + 'x ' + (pr.hqMonths === 1 ? 'Month' : 'Months') + ' @ ' + pr.monthlyDisplay + (pr.dailyRate ? ' <span style="opacity:0.45;font-size:0.85em">(' + money(pr.monthlyRate/30) + '/day)</span>' + (Math.round((1-(pr.monthlyRate/30)/pr.dailyRate)*100) >= 1 ? ' <span style="color:#4ade80;font-size:0.8em;font-weight:600">' + Math.round((1-(pr.monthlyRate/30)/pr.dailyRate)*100) + '% off</span>' : '') : '') + '</span><span>' + (pr.monthlyPortionDisplay || money(pr.monthlyPortion)) + '</span></div>';
    }
    if (pr.hqWeeks > 0 && pr.weeklyRate != null) {
      lines += '<div class="ark-popup__sum-line"><span>' + pr.hqWeeks + 'x ' + (pr.hqWeeks === 1 ? 'Week' : 'Weeks') + ' @ ' + pr.weeklyDisplay + (pr.dailyRate ? ' <span style="opacity:0.45;font-size:0.85em">(' + money(pr.weeklyRate/7) + '/day)</span>' + (Math.round((1-(pr.weeklyRate/7)/pr.dailyRate)*100) >= 1 ? ' <span style="color:#4ade80;font-size:0.8em;font-weight:600">' + Math.round((1-(pr.weeklyRate/7)/pr.dailyRate)*100) + '% off</span>' : '') : '') + '</span><span>' + (pr.weeklyPortionDisplay || money(pr.weeklyPortion)) + '</span></div>';
    }
    if (pr.hqDays > 0 && pr.dailyRate != null) {
      lines += '<div class="ark-popup__sum-line"><span>' + pr.hqDays + 'x ' + (pr.hqDays === 1 ? 'Day' : 'Days') + ' @ ' + pr.dailyDisplay + '</span><span>' + (pr.dailyPortionDisplay || money(pr.dailyPortion)) + '</span></div>';
    }
    if (!lines) {
      lines = '<div class="ark-popup__sum-line"><span>' + s.days + 'x Days @ ' + s.dailyDisplay + '</span><span>' + (s.baseTotalDisplay || '—') + '</span></div>';
    }
    return lines;
  };

  /* Step 4: Confirm */
  Popup.prototype._renderConfirm = function () {
    var s = this.st;
    var sum = $(this.root, '[data-ark-confirm-summary]');
    var pickD = this.pickCal ? this.pickCal.getValue() : '';
    var retD = this.retCal ? this.retCal.getValue() : '';
    var pickT = this.pickTime ? this.pickTime.getValue() : '';
    var retT = this.retTime ? this.retTime.getValue() : '';
    var pickLocStr = s.pickLocLabel ? ' — ' + s.pickLocLabel : '';
    var retLocStr = s.retLocLabel ? ' — ' + s.retLocLabel : '';
    var hasCustomLoc = s.pickLocCustom || s.retLocCustom;
    var customNotice = hasCustomLoc
      ? '<div class="ark-popup__confirm-notice" style="margin-top:12px;padding:12px 16px;background:rgba(255,215,0,0.08);border:1px solid rgba(255,215,0,0.2);border-radius:8px;font-size:13px;line-height:1.5;color:#b8a040">' +
        'Delivery to custom address — our concierge will confirm pricing. <a href="tel:+17865531077" style="color:#ffd700;text-decoration:none;font-weight:600">(786) 553-1077</a></div>'
      : '';
    var discountLine = s.couponDiscount != null
      ? '<div class="ark-popup__sum-line" style="color:#4ade80"><span>Discount (' + s.couponLabel + ')</span><span>-' + money(s.couponDiscount) + '</span></div>'
      : '';
    sum.innerHTML =
      '<div class="ark-popup__confirm-block"><p class="ark-popup__confirm-label">Pickup</p><p>' + fmtDisplay(pickD) + ' @ ' + to12h(pickT) + pickLocStr + '</p></div>' +
      '<div class="ark-popup__confirm-block"><p class="ark-popup__confirm-label">Return</p><p>' + fmtDisplay(retD) + ' @ ' + to12h(retT) + retLocStr + '</p></div>' +
      customNotice +
      '<hr class="ark-popup__hr">' +
      '<div class="ark-popup__confirm-block"><p class="ark-popup__confirm-label">' + s.vName + '</p>' +
      this._buildRateBreakdownLines() +
      '<div class="ark-popup__sum-line"><span>Sales Tax (7%)</span><span>' + (s.taxAmount != null ? money(s.taxAmount) : '—') + '</span></div>' +
      '<div class="ark-popup__sum-line"><span>Included distance</span><span>' + (s.milesPerDay != null ? s.milesPerDay + ' ' + s.mileUnit + ' / day' : '—') + '</span></div>' +
      discountLine +
      '<hr class="ark-popup__hr">' +
      '<div class="ark-popup__sum-line" style="font-weight:700;font-size:16px"><span>Total</span><span>' + s.totalDisplay + '</span></div></div>';

    var self = this;
    var couponWrap = $(this.root, '[data-ark-coupon-wrap]');
    if (couponWrap) {
      if (s.couponCode) {
        couponWrap.innerHTML = '<div class="ark-popup__coupon-applied"><span>Code applied: <strong>' + s.couponCode + '</strong></span><button type="button" class="ark-popup__coupon-remove" data-ark-coupon-remove title="Remove">&times;</button></div>';
        var removeBtn = $(couponWrap, '[data-ark-coupon-remove]');
        if (removeBtn) removeBtn.addEventListener('click', function () { self._removeCoupon(); });
      } else {
        couponWrap.innerHTML =
          '<div class="ark-popup__coupon-row">' +
            '<input type="text" class="ark-popup__input ark-popup__coupon-input" data-ark-coupon-input placeholder="Discount or member code">' +
            '<button type="button" class="ark-popup__coupon-btn" data-ark-coupon-apply>Apply</button>' +
          '</div>' +
          '<p class="ark-popup__coupon-hint" style="margin-top:6px;font-size:12px;opacity:0.55;line-height:1.4">Members: enter your access code for 25% off and included drive days.</p>' +
          '<p class="ark-popup__coupon-msg ark-popup__coupon-msg--hidden" data-ark-coupon-msg></p>';
        var applyBtn = $(couponWrap, '[data-ark-coupon-apply]');
        if (applyBtn) applyBtn.addEventListener('click', function () { self._applyCoupon(); });
        var inp = $(couponWrap, '[data-ark-coupon-input]');
        if (inp) inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self._applyCoupon(); } });
      }
    }

    this.goToStep(4);
  };

  Popup.prototype._applyCoupon = function () {
    var inp = $(this.root, '[data-ark-coupon-input]');
    var msg = $(this.root, '[data-ark-coupon-msg]');
    var btn = $(this.root, '[data-ark-coupon-apply]');
    if (!inp) return;
    var code = inp.value.trim();
    if (!code) { this._showCouponMsg(msg, 'Please enter a discount code.', false); return; }

    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    var self = this;
    var isYves = code.toUpperCase() === 'YVES';
    var body = Object.assign({}, this.st.datesQuery, isYves ? { manual_discount: 20, manual_discount_is_percentage: true } : { coupon_code: code });

    this._api('/api/reservation/price', { method: 'POST', body: body }).then(function (r) {
      if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
      var hqFailed = !r.ok || (r.data && r.data.success === false);
      if (hqFailed) {
        var errMsg = (r.data && r.data.errors && r.data.errors.error_message) || (r.data && r.data.errors && r.data.errors.coupon_code && r.data.errors.coupon_code[0]) || (r.data && r.data.message) || 'Invalid discount code.';
        self._showCouponMsg(msg, errMsg, false);
        return;
      }

      var data = (r.data && r.data.data) || r.data || {};
      var svc = data.selected_vehicle_class || {};
      var price = svc.price || data.price || {};
      var total = data.total || {};
      var discounts = data.applicable_discounts || [];

      var newTotal = total.total_price ? parseFloat(total.total_price.amount) : (price.base_price_with_taxes ? parseFloat(price.base_price_with_taxes.amount) : null);
      var newTotalDisplay = total.total_price ? total.total_price.amount_for_display : (price.base_price_with_taxes ? price.base_price_with_taxes.amount_for_display : null);
      var oldTotal = self.st.totalWithTax;

      if (discounts.length > 0 && newTotal != null) {
        var disc = discounts[0];
        var discountAmt = disc.discounted_amount ? parseFloat(disc.discounted_amount.amount) : 0;
        var discountName = code.toUpperCase() === 'YVES' ? 'YVES (20%)' : (disc.name || code.toUpperCase());

        self.st.couponCode = code;
        self.st.couponDiscount = discountAmt;
        self.st.couponLabel = discountName;
        self.st.totalWithTax = newTotal;
        self.st.totalDisplay = newTotalDisplay || money(newTotal);
        if (price.base_price) {
          self.st.baseTotal = parseFloat(price.base_price.amount);
          self.st.baseTotalDisplay = price.base_price.amount_for_display || money(self.st.baseTotal);
        }
        var taxes = data.applicable_taxes || [];
        if (taxes.length > 0 && taxes[0].total_amount) {
          self.st.taxAmount = parseFloat(taxes[0].total_amount.amount);
        }
        self._renderConfirm();
      } else if (newTotal != null && oldTotal != null && newTotal < oldTotal) {
        self.st.couponCode = code;
        self.st.couponDiscount = oldTotal - newTotal;
        self.st.couponLabel = code.toUpperCase();
        self.st.totalWithTax = newTotal;
        self.st.totalDisplay = newTotalDisplay || money(newTotal);
        self._renderConfirm();
      } else {
        self._showCouponMsg(msg, 'This code is not valid or does not apply to this booking.', false);
      }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
      self._showCouponMsg(msg, 'Network error. Please try again.', false);
    });
  };

  Popup.prototype._removeCoupon = function () {
    var pricing = this.st.selectedClassPricing;
    if (pricing) {
      this.st.totalWithTax = pricing.totalWithTax;
      this.st.totalDisplay = pricing.totalDisplay;
      this.st.baseTotal = pricing.baseTotal;
      this.st.baseTotalDisplay = pricing.totalForPeriod || money(pricing.baseTotal);
      this.st.taxAmount = pricing.taxAmount;
    }
    this.st.couponCode = '';
    this.st.couponDiscount = null;
    this.st.couponLabel = '';
    this._renderConfirm();
  };

  Popup.prototype._showCouponMsg = function (el, text, isSuccess) {
    if (!el) return;
    el.textContent = text;
    el.classList.remove('ark-popup__coupon-msg--hidden', 'ark-popup__coupon-msg--success', 'ark-popup__coupon-msg--error');
    el.classList.add(isSuccess ? 'ark-popup__coupon-msg--success' : 'ark-popup__coupon-msg--error');
  };

  Popup.prototype.submitConfirm = function () {
    this._noErr(4);
    if (!$(this.root, '[data-ark-terms]').checked) { this._err(4, 'Please accept the Terms & Conditions.'); return; }
    var self = this; this._load(4, true);
    var body = Object.assign({}, this.st.datesQuery, {
      customer_id: this.st.customerId,
      vehicle_class_id: this.st.vcId,
      payment_method_id: this.payMethodId,
      payment_redirect_url: this.payRedirect,
      redirect_url: this.payRedirect,
      customer_first_name: this.st.custFirstName,
      customer_last_name: this.st.custLastName,
      customer_email: this.st.custEmail,
      customer_phone_number: this.st.custPhone,
      // Opt in to Shopify-checkout flow: relay creates a draft order and
      // returns _shopify.invoice_url so we can redirect into Shopify Checkout.
      shopify_checkout: 'true',
      shopify_product_handle: this.st.handle || '',
      vehicle_label: this.st.vName || '',
      days: this.st.days || '',
      booking_total: (this.st.totalWithTax != null ? this.st.totalWithTax : ''),
      currency: 'USD',
      pickup_display: (this.st.datesQuery.pick_up_date || '') + (this.st.datesQuery.pick_up_time ? ' ' + this.st.datesQuery.pick_up_time : ''),
      return_display: (this.st.datesQuery.return_date || '') + (this.st.datesQuery.return_time ? ' ' + this.st.datesQuery.return_time : ''),
      pickup_location_label: (this.st.pickLocCustom ? (this.st.datesQuery.pick_up_location_custom || this.st.pickLocLabel) : this.st.pickLocLabel) || '',
      return_location_label: (this.st.retLocCustom ? (this.st.datesQuery.return_location_custom || this.st.retLocLabel) : (this.st.retLocLabel || this.st.pickLocLabel)) || ''
    });
    if (this.st.couponCode) {
      if (this.st.couponCode.toUpperCase() === 'YVES') {
        body.manual_discount = 20;
        body.manual_discount_is_percentage = true;
      } else {
        body.coupon_code = this.st.couponCode;
      }
    }
    trackMeta('Booking_Step_4_Confirm', { vehicle_name: self.st.vName, days: self.st.days, total: self.st.totalDisplay, coupon: self.st.couponCode || 'none' , value: (self.st.totalWithTax != null ? self.st.totalWithTax : 0), currency: 'USD' });
    self.st.converted = true; self._fireDemand(true);
    this._api('/api/reservation/confirm', { method: 'POST', body: body }).then(function (r) {
      self._load(4, false);
      if (!r.ok) { self._err(4, (r.data && r.data.message) || 'Could not confirm reservation.'); return; }
      var inv = r.data && r.data._shopify && r.data._shopify.invoice_url;
      if (inv) { window.location.assign(inv); return; }
      self._showReservationSuccess();
    }).catch(function () { self._load(4, false); self._err(4, 'Network error.'); });
  };

  function init() {
    var root = document.getElementById('ark-booking-popup-root');
    if (root) {
      var popup = new Popup(root);
      window.arkBookingPopup = popup;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.ark-book-now-trigger');
        if (!btn) return; e.preventDefault(); e.stopPropagation();
        popup.open({ vehicleClassId: btn.getAttribute('data-vehicle-class-id') || '', name: btn.getAttribute('data-vehicle-name') || '', image: btn.getAttribute('data-vehicle-image') || '', handle: btn.getAttribute('data-product-handle') || '', productUrl: btn.getAttribute('data-product-url') || '', price: btn.getAttribute('data-vehicle-price') || '' });
      }, true);
    }
    var pdpRoot = document.getElementById('ark-booking-pdp-root');
    if (pdpRoot) {
      var pdp = new Popup(pdpRoot);
      window.arkBookingPdp = pdp;
      pdp.open({
        vehicleClassId: pdpRoot.getAttribute('data-vehicle-class-id') || '',
        name: pdpRoot.getAttribute('data-vehicle-name') || '',
        image: pdpRoot.getAttribute('data-vehicle-image') || '',
        handle: pdpRoot.getAttribute('data-product-handle') || '',
        productUrl: pdpRoot.getAttribute('data-product-url') || '',
        price: pdpRoot.getAttribute('data-vehicle-price') || ''
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

